import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "@i18n/hooks";
import { DiscountTypeKind } from "@relay/discountActionForm_DiscountActionFragment.graphql";
import { DiscountTypeInputProps } from "./discount-type-input.types";

export const DiscountTypeInput = ({ fieldValue, updateField }: DiscountTypeInputProps) => {
	const { t } = useTranslation("common");

	const options: { label: string; value: DiscountTypeKind }[] = [
		{ label: t("discounts.discountTypeSystem"), value: "System" },
		{ label: t("discounts.discountTypeUser"), value: "User" },
	];

	return (
		<Dropdown
			value={options.find((k) => k.value === fieldValue)?.value}
			options={options}
			placeholder={t("discounts.discountType")}
			onChange={(e) => updateField(e.value)}
		/>
	);
};
